'use client';

import React from 'react';
import { useFilters } from '@/context/FiltersContext';
import type { TargetAudience } from '@/types/filters';

const OPTIONS: TargetAudience[] = ['B2B', 'B2C', 'Both'];

export const TargetAudienceFilter: React.FC = () => {
  const { filters, updateFilter } = useFilters();

  const toggle = (value: TargetAudience): void => {
    updateFilter('targetAudience', filters.targetAudience === value ? null : value);
  };

  return (
    <div>
      <div className="text-[9px] font-semibold tracking-[0.12em] uppercase text-text-muted pb-[6px]">Audience</div>
      <div className="flex gap-[4px]">
        {OPTIONS.map(opt => {
          const active = filters.targetAudience === opt;
          return (
            <button
              key={opt}
              type="button"
              onClick={() => toggle(opt)}
              className={`text-[10px] font-medium px-[8px] py-[3px] rounded-sm border transition-colors cursor-pointer tracking-[0.03em] ${
                active
                  ? 'border-accent text-accent bg-accent-dim'
                  : 'border-border text-text-muted hover:border-border-mid hover:text-text-secondary'
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
};
